import { render, staticRenderFns } from "./OrderHoldingTime.vue?vue&type=template&id=76f05fda&"
import script from "./OrderHoldingTime.vue?vue&type=script&lang=js&"
export * from "./OrderHoldingTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports